<script lang="ts">
	//Services
	import { localReq, postReq } from '../../../../services/http';
	import { format } from '../../../../services/i18n';
	//Stores
		import { getDeviceStatus, getDeviceSettings } from 'src/stores/device-runtime/status-selectors';
	//Helpers
	import { get_local_ip, real_id } from '../../../../helpers/interface_helpers';
	//Design system components
	import { Button, Input, toast } from '@Shelly/shelly-design-system';

	export let device;

	const id = real_id(device.id);

	$: settingsStore = getDeviceSettings(id);
	$: settings = $settingsStore;
	let min = 50,
		max = 150;

	let value = settings.zcross_debounce;
	let cache = value;
	let localIp = get_local_ip(id);

	const setAflDebounce = async () => {
		if (cache !== value) {
			let res;

			if (localIp) {
				res = await localReq(device, `${localIp}/settings/`, 'post', {
					zcross_debounce: value,
				});
			} else {
				res = await postReq(`/device/${device.category}/settings/zcross_debounce`, {
					id: device.id,
					time: value,
				});
			}

			if (res.isok) {
				toast.open({
					type: 'success',
					title:
						$format('anti_flickering_change_scc_toast', {
							values: { value },
						}) || `Antiflickering debounce was changed to ${value}ms.`,
				});
				settings.zcross_debounce = value;
				devices_settings.update_devices_settings(device.id, settings);
				cache = value;
			} else {
				value = cache;
				toast.open({ type: 'danger', title: $format('error_global') });
			}
		}
	};
</script>

<Input
	size="m"
	class="mb-s"
	bind:value
	type={'number'}
	{min}
	{max}
	info={$format('anti_flickering_debounce_description', {
		values: { min, max },
		default: 'Anti-flickering debounce:  ({min} - {max}) miliseconds.',
	})}
	on:enter={setAflDebounce}
	id="input-3483bdr"
	aria-label={$format('anti_flickering_debounce_description', {
		values: { min, max },
		default: 'Anti-flickering debounce:  ({min} - {max}) miliseconds.',
	})}
/>
<Button size="m" width="full" on:click={setAflDebounce}>{$format('button_save')}</Button>
